export const CITY_NEIGHBORS: Record<string, string[]> = {
  // Costa Occidental
  'estepona': ['marbella', 'mijas', 'serrania-de-ronda'],
  'marbella': ['estepona', 'mijas', 'fuengirola'],
  'mijas': ['marbella', 'fuengirola', 'benalmadena'],
  'fuengirola': ['mijas', 'benalmadena', 'marbella'],
  'benalmadena': ['fuengirola', 'torremolinos', 'mijas'],
  'torremolinos': ['benalmadena', 'malaga', 'fuengirola'],

  // Capital et alrededores
  'malaga': ['torremolinos', 'rincon-de-la-victoria', 'alhaurin-de-la-torre', 'cartama'],
  'rincon-de-la-victoria': ['malaga', 'velez-malaga', 'axarquia'],

  // Costa Oriental / Axarquia
  'velez-malaga': ['rincon-de-la-victoria', 'torrox', 'axarquia'],
  'torrox': ['velez-malaga', 'nerja', 'axarquia'],
  'nerja': ['torrox', 'velez-malaga', 'axarquia'],

  // Valle del Guadalhorce
  'cartama': ['alhaurin-de-la-torre', 'coin', 'valle-del-guadalhorce', 'malaga'],
  'alhaurin-de-la-torre': ['cartama', 'malaga', 'alhaurin-el-grande'],
  'alhaurin-el-grande': ['alhaurin-de-la-torre', 'coin', 'mijas'],
  'coin': ['cartama', 'alhaurin-el-grande', 'valle-del-guadalhorce'],
  'alora': ['cartama', 'valle-del-guadalhorce', 'antequera'],

  // Interior nord
  'antequera': ['alora', 'valle-del-guadalhorce', 'ronda'],
  'ronda': ['antequera', 'serrania-de-ronda', 'estepona'],

  // Hubs regionaux — neighbors = villes Tier 1/2 limitrophes
  'axarquia': ['velez-malaga', 'nerja', 'torrox', 'rincon-de-la-victoria'],
  'valle-del-guadalhorce': ['cartama', 'coin', 'alora', 'alhaurin-el-grande'],
  'serrania-de-ronda': ['ronda', 'estepona'],
};

export const CITY_LABELS: Record<string, string> = {
  'malaga': 'Málaga',
  'marbella': 'Marbella',
  'fuengirola': 'Fuengirola',
  'torremolinos': 'Torremolinos',
  'benalmadena': 'Benalmádena',
  'mijas': 'Mijas',
  'estepona': 'Estepona',
  'velez-malaga': 'Vélez-Málaga',
  'rincon-de-la-victoria': 'Rincón de la Victoria',
  'cartama': 'Cártama',
  'alhaurin-de-la-torre': 'Alhaurín de la Torre',
  'alhaurin-el-grande': 'Alhaurín el Grande',
  'antequera': 'Antequera',
  'coin': 'Coín',
  'nerja': 'Nerja',
  'torrox': 'Torrox',
  'alora': 'Álora',
  'ronda': 'Ronda',
  'axarquia': 'Axarquía',
  'valle-del-guadalhorce': 'Valle del Guadalhorce',
  'serrania-de-ronda': 'Serranía de Ronda',
};

export function getNeighbors(slug: string): { slug: string; label: string }[] {
  return (CITY_NEIGHBORS[slug] || []).map((s) => ({ slug: s, label: CITY_LABELS[s] || s }));
}

export function getNearbyCitySlugs(currentSlug: string, limit = 4): string[] {
  return (CITY_NEIGHBORS[currentSlug] || []).slice(0, limit);
}